import {
  rootFontSizePx
} from "./chunk-RNCUEVKR.js";

// src/styles/utils.tsx
import { css } from "@emotion/react";
function pxToRems(rems, asNum = false) {
  const value = (rems / rootFontSizePx).toFixed(6);
  return asNum ? Number(value) : `${value}rem`;
}
function remsToPx(rems, asNum = false) {
  const value = (rootFontSizePx * rems).toFixed(6);
  return asNum ? Number(value) : `${value}px`;
}
var extend = (...args) => css(...args);
var size = {
  px8: pxToRems(8),
  px10: pxToRems(10),
  px12: pxToRems(12),
  px14: pxToRems(14),
  px16: pxToRems(16),
  px18: pxToRems(18),
  px20: pxToRems(20),
  px21: pxToRems(21),
  px24: pxToRems(24)
};
var flexCenterAxis = css`
  display: flex;
  align-items: center;
`;
var flexCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;
var inlineFlexCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;
var flexBetween = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
var absoluteCenter = css`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
`;
var textCenter = css`
  text-align: center;
`;
var overflowAutoWithoutScrollbars = css`
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  &::-moz-scrollbar {
    display: none;
  }
`;
var lineClamp = (lines) => css`
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
var ignoreSSRWarning = "/* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */";
var firstChild = (style) => `&:first-child:not(style), style:first-child + & ${ignoreSSRWarning} { ${style} }`;

export {
  pxToRems,
  remsToPx,
  extend,
  size,
  flexCenterAxis,
  flexCenter,
  inlineFlexCenter,
  flexBetween,
  absoluteCenter,
  textCenter,
  overflowAutoWithoutScrollbars,
  lineClamp,
  ignoreSSRWarning,
  firstChild
};
